import { useAuth } from "@/hooks/auth";
import React from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";

const GuestRoute = () => {
    const { isAuthenticated } = useAuth()
    const [searchParams] = useSearchParams()
    if (isAuthenticated) {
        if (searchParams.get('redirect')) {
            return <Navigate to={searchParams.get('redirect') ?? '/dashboard'} />
        }
        return <Navigate to={'/dashboard'} />
    }
    return (
        <Outlet />
    )

}

export default GuestRoute;
